import { BotUser } from "../../../../API/Users/models";

export const getUserStatus = (user: BotUser) => {
    const tenMinutesAgo: Date = new Date(new Date().getTime() - 10 * 60000);

    if (user.blocked) {
        return { color: 'text-white', text: 'Bloqueado', bg: 'danger' };
    }

    if (!user?.lastActionDate || !user?.loginDate) {
        return { color: 'text-warning', text: 'Inactivo', bg: '' };
    }

    const lastActionDate = new Date(user.lastActionDate);
    const loginDate = new Date(user.loginDate);

    if (lastActionDate > tenMinutesAgo || loginDate > tenMinutesAgo) {
        return { color: 'text-white', text: 'Activo', bg: 'success' };
    } else {
        return { color: 'text-warning', text: 'Inactivo', bg: '' };
    }
  }